import { render, staticRenderFns } from "./scoresQuery.vue?vue&type=template&id=6ccf3207&scoped=true"
import script from "./scoresQuery.vue?vue&type=script&lang=js"
export * from "./scoresQuery.vue?vue&type=script&lang=js"
import style0 from "./scoresQuery.vue?vue&type=style&index=0&id=6ccf3207&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf3207",
  null
  
)

export default component.exports